import * as Yup from 'yup'

const splitScheduleValidator = Yup.object ({
  service: Yup
    .object ()
    .nullable ()
    .required ('Selecione o serviço'),

  professionalTwo: Yup
    .object ()
    .nullable ()
    .required ('Selecione um profissional'),

  serviceTwo: Yup
    .object ()
    .nullable ()
    .required ('Selecione o serviço'),

  timeTwo: Yup
    .object ()
    .nullable ()
    .required ('Selecione o horário')
})

export default splitScheduleValidator
